import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  bootstrapFirebaseFromEnv,
  consumeCrossPanelHandoff,
  initSentry,
} from "@workspace/admin-ui";
import App from "./App";

initSentry({
  appName: "pharmacy-admin",
  env: import.meta.env as unknown as Record<string, string | undefined | boolean>,
});

bootstrapFirebaseFromEnv(
  import.meta.env as Record<string, string | undefined>,
  "artifacts/pharmacy-admin",
);

// Cross-panel role switch may hand this tab a fresh session — consume it
// before the auth listener mounts so we never flash the login screen.
await consumeCrossPanelHandoff();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
